import React from 'react'

import bgContact from '../../../assets/bgServicesLS.png'
import PrimeButton from '../../../components/PrimeButton'

export default function LastSection() {
  return (
    <section className={` bg-no-repeat bg-cover  py-20 text-white w-full text-center flex flex-col items-center`} style={{backgroundImage:`url(${bgContact})`}}>
        <h4 className='font-[700] text-[32px] md:w-[50%]'>
          
         Maximize Value and Stay Ahead with H2A’s Upgrade and Trade-In Services

          
          </h4>
        <p className='my-5 font-[300] text-lg md:text-[20px] md:w-[50%]'>
          
H2A offers upgrade and trade-in services to help healthcare providers stay current with the latest technology. These services extend equipment life, enhance reliability, and support consistent, cost-effective operations now and into the future.          
          
          </p>
        <PrimeButton bgColor='#ffffff' bgHover='bg-gray-200' txtColor='#005CB9' text='Request a service' />
    </section>
  )
}
